import importReact from "../../utils/importReact";

export default function initIndustryEvents() {
  const entrypoint = document.getElementById("industry-events-container");
  if (entrypoint) {
    import(/* webpackChunkName: "industryEvents" */ "./IndustryEvents").then(
      (e) => {
        const pageSize = parseInt(entrypoint.dataset.pagesize);
        const currentPageRef = parseInt(entrypoint.dataset.currentpage);
        importReact().then(([React, ReactDOM]) => {
          ReactDOM.render(
            React.createElement(e.default, {
              pageSize,
              currentPageRef
            }),
            entrypoint
          );
        });
      }
    );
  }
}
